<!-- signature modal -->

<div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <!-- Background Overlay -->
    <div class="fixed inset-0 bg-[#363738] bg-opacity-25 backdrop-blur-sm transition-opacity dark:bg-[#3333331f]"></div>
    <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
            <div class="fixed inset-y-0 right-0 flex max-w-full pl-4 sm:pl-8">
                <div class="w-screen max-w-xl px-4 py-4">
                    <!-- Modal Content -->
                    <div
                        class="flex h-full flex-col overflow-hidden rounded-lg border border-zinc-950/10 bg-white shadow-xl dark:border-white/10 dark:bg-zinc-950">
                        <div class="border-b border-zinc-200 px-4 py-2 dark:border-white/10">
                            <div class="flex items-center justify-between">
                                <h3 class="heading" id="slide-over-title">WillCall Activate</h3>
                                <div class="ml-3 flex h-7 items-center space-x-4">
                                    <button (click)="onCloseModal()"
                                        class="rounded-md bg-white text-zinc-500 hover:text-zinc-700 focus:ring-2 focus:ring-primary dark:bg-white/5 dark:text-white dark:hover:text-zinc-300"
                                        type="button">
                                        <span class="sr-only">Close panel</span>
                                        <svg aria-hidden="true" class="h-6 w-6" fill="none" stroke="currentColor"
                                            stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round"
                                                stroke-linejoin="round"></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- Form Start -->
                        <form [formGroup]="willCallForm" (ngSubmit)="onSubmit()"
                            class="flex-1 flex flex-col gap-4 overflow-y-auto p-4">
                            <!-- Time Field -->
                            <div class="sm:col-span-2" formGroupName="pickup">
                                <label for="willCallPickUpTime" class="block text-sm font-medium text-main-secondary">
                                    Time
                                </label>

                                <div class="mt-1 relative">
                                    <input type="text" id="willCallPickUpTime" formControlName="time"
                                        [owlDateTime]="dtPickUpTime" [owlDateTimeTrigger]="dtPickUpTime"
                                        class="block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring focus:ring-primary/50 sm:text-sm" />
                                    <owl-date-time (afterPickerClosed)="onDateChange(willCallForm.get('pickup.time'))" #dtPickUpTime></owl-date-time>
                                </div>

                                <div *ngIf="willCallForm.get('pickup.time')?.errors && isSubmitted">
                                    <p class="mt-2 text-red-600 text-xs"
                                        *ngIf="willCallForm.get('pickup.time')?.errors?.required">
                                        Time is required
                                    </p>
                                </div>
                            </div>


                            <!-- Notes Field -->
                            <div class="sm:col-span-2">
                                <label for="willCallNotes"
                                    class="block text-sm font-medium text-main-secondary">Notes</label>
                                <textarea id="willCallNotes" formControlName="willCallNotes" rows="3"
                                    class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring focus:ring-primary/50 sm:text-sm"
                                    placeholder="Notes..."></textarea>
                            </div>

                            <div class="flex items-center gap-2 mt-4">
                                <label class="subheading">Expected</label>
                            
                                <label
                                    class="relative inline-flex h-6 w-12 cursor-pointer rounded-full bg-zinc-950/5 dark:bg-white/5 transition-colors duration-200 ease-in-out">
                                    <input type="checkbox" (ngModelChange)="toggleExpected($event)" [ngModelOptions]="{standalone: true}" class="sr-only peer" [(ngModel)]="isExpected" />
                            
                                    <span class="pointer-events-none absolute left-0 top-0 h-6 w-6 rounded-full bg-white shadow transform transition-transform duration-200 ease-in-out
                                    peer-checked:translate-x-6 peer-checked:bg-green-500">
                                        <svg class="h-3 w-3 text-red-500 absolute inset-0 m-auto transition-opacity duration-200" fill="none"
                                            viewBox="0 0 12 12" [class.opacity-0]="isExpected" [class.opacity-100]="!isExpected">
                                            <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                            
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                            stroke="currentColor" class="h-3 w-3 text-white absolute inset-0 m-auto transition-opacity duration-200"
                                            [class.opacity-0]="!isExpected" [class.opacity-100]="isExpected">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                        </svg>
                                    </span>
                                </label>
                            </div>

                            <!-- Submit Button -->
                            <div class="flex items-center justify-end gap-2">
                                <button type="submit" class="btn btn-secondary">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>